// extracted by mini-css-extract-plugin
module.exports = {"container":"lIiB4A","title":"iZLMmr","list":"Z6kAtY","subtitle":"XDTYdO"};